import { Select } from 'antd';
import React, { ReactElement } from 'react';

interface SidebarSelectProps {
  currentValue?: string;
  defaultValue?: string;
  disabled?: boolean;
  existingItems?: string[];
  noMargin?: boolean;
  onSelectChange?: (value: string) => void;
  selectOptions: string[];
  stateColorMapping?: Record<string, string>;
  width?: string;
}

function SidebarSelect({
  currentValue,
  defaultValue = 'Select Status',
  disabled,
  existingItems = [],
  noMargin,
  onSelectChange,
  selectOptions,
  stateColorMapping,
  width = '100%',
}: SidebarSelectProps): ReactElement {
  const handleChange = (value: string) => {
    if (onSelectChange) {
      onSelectChange(value);
    }
  };

  const upperCaseValue = currentValue?.toUpperCase();
  const backgroundColor = stateColorMapping ? stateColorMapping[upperCaseValue || ''] : '';

  return (
    <Select
      disabled={disabled}
      value={upperCaseValue}
      placeholder={defaultValue}
      onChange={handleChange}
      style={{
        backgroundColor: backgroundColor,
        margin: noMargin ? 0 : '5px 0',
        width: width,
        fontSize: 14,
        fontWeight: 'bold',
      }}
      options={selectOptions.map((selected) => ({
        value: selected,
        label: selected,
        disabled: existingItems.includes(selected),
        style: {
          fontSize: 14,
          textTransform: 'uppercase' as const,
        },
      }))}
    />
  );
}

export default SidebarSelect;
